import { FC, useEffect, useState } from 'react'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import { makeStyles } from '@material-ui/core'
import useTranslate from '../../../i18n/useTranslate'
import _ from 'lodash'
import { CommitteesType, ReviewerResponseType } from '../../../services/um/useSearchReviewer'
import { setPrefixName } from '../../../utilities/prefixName'
import CustomPagination from '../../report/closed/CustomPagination'
import CustomNoRowsOverlay from '../../report/closed/CustomNoRowsOverlay'
import { CustomSortingASCcending, CustomSortingDescending } from '../../report/closed/CusromSorting'
import { convertDateToFormatEN, convertDateToFormatTH } from '../../../utilities/date'
interface DataTableProps {
    data: ReviewerResponseType[]
}

type ReviewerDataRowsType = {
    id: number
    name: string
    projectNumber: string
    projectType: string
    projectNameTH: string
    projectNameEN: string
    committee: string
    receiveDate: string
}

const DataTable: FC<DataTableProps> = ({ data }) => {
    const classes = useStyles()
    const translate = useTranslate()
    const lang = translate.languageStore.currentLanguage as 'th' | 'en'
    const [dataList, setDataList] = useState<ReviewerDataRowsType[]>([])

    useEffect(() => {
        setDataFormat()
    }, [data, lang])

    const getCommitte = (data: CommitteesType[]) => {
        let result = data.map((item, index) => {
            return setPrefixName(item)[lang]
        })
        return result.join(', ')
    }

    const setDataFormat = () => {
        let convertData: ReviewerDataRowsType[] = data.map((itm) => {
            getCommitte(itm.committees)
            return {
                id: itm.projectID,
                name: setPrefixName(itm)[lang],
                projectNumber: itm.projectNumber,
                projectNameTH: itm.projectName.th,
                projectNameEN: itm.projectName.en,
                projectType: itm.projectType.name[lang],
                committee: getCommitte(itm.committees),
                receiveDate:
                    translate.languageStore.currentLanguage === translate.languageKey.th
                        ? convertDateToFormatTH(itm.receiveDate)
                        : convertDateToFormatEN(itm.receiveDate),
            }
        })

        setDataList(convertData)
    }

    const column: GridColDef[] = [
        {
            field: 'projectNumber',
            headerName: translate.get('UM.REVIEWER.DATA_TABLE.COLUMN1'),
            width: 200,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'name',
            headerName: translate.get('UM.REVIEWER.DATA_TABLE.COLUMN2'),
            width: 330,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'projectType',
            headerName: translate.get('UM.REVIEWER.DATA_TABLE.COLUMN3'),
            type: 'string',
            width: 200,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'projectNameTH',
            headerName: translate.get('UM.REVIEWER.DATA_TABLE.COLUMN4'),
            type: 'string',
            width: 300,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'projectNameEN',
            headerName: translate.get('UM.REVIEWER.DATA_TABLE.COLUMN5'),
            type: 'string',
            width: 300,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'committee',
            headerName: translate.get('UM.REVIEWER.DATA_TABLE.COLUMN6'),
            type: 'string',
            width: 370,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'receiveDate',
            headerName: translate.get('UM.REVIEWER.DATA_TABLE.COLUMN7'),
            type: 'string',
            width: 200,
            headerClassName: 'super-app-theme--header',
        },
    ]

    return (
        <div style={{ width: '100%', marginTop: 16 }}>
            <DataGrid
                className={classes.root}
                rows={dataList}
                columns={column}
                autoHeight={true}
                pagination
                pageSize={10}
                rowsPerPageOptions={[10]}
                sortingOrder={['asc', 'desc']}
                disableColumnMenu={true}
                disableSelectionOnClick={true}
                components={{
                    Pagination: CustomPagination,
                    NoRowsOverlay: CustomNoRowsOverlay,
                    // ColumnSortedDescendingIcon: CustomSortingDescending,
                    // ColumnSortedAscendingIcon: CustomSortingASCcending,
                }}
            />
        </div>
    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        '& .super-app-theme--fffff': {
            backgroundColor: '#DB5F8E',
            '&:hover': {
                backgroundColor: '#DB5F8E',
            },
        },
        '& .super-app-theme--header': {
            backgroundColor: theme.palette.primary.main,
            color: '#fff',
        },
        '& .MuiDataGrid-columnSeparator': {
            visibility: 'hidden',
        },
        '& .MuiDataGrid-row': {
            lineHeigh: '70px',
        },

        '& .header-table': {
            backgroundColor: '#DB5F8E',
            color: '#FFFFFF',
        },
        '& .MuiDataGrid-iconSeparator': {
            display: 'none',
        },
        '& .MuiDataGrid-sortIcon': {
            color: '#FFFFFF',
        },
        '& .MuiBadge-anchorOriginTopRightRectangle': {
            display: 'none',
        },
        '& .MuiDataGrid-cell:focus-within': {
            outline: 'none',
        },
        '& .MuiDataGrid-row, .MuiDataGrid-root .MuiDataGrid-cell, .rendering-zone': { 'max-height': 'none !important' },
        '.MuiDataGrid-root .MuiDataGrid-window': { position: 'relative !important' },
        '.MuiDataGrid-root .MuiDataGrid-viewport': { 'max-height': 'none !important' },
        '.MuiDataGrid-root': { height: 'auto !important' },
        width: '100%',
        marginTop: 16,
        overflowX: 'hidden',
    },
}))

export default DataTable
